import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const Spinner = styled.div`
  margin: var(--grid-32);
  display: inline-block;
  height: 48px;
  width: 48px;
  animation: ${spin} 1.5s linear infinite;
  border-radius: 9999px;
  border: 4px solid currentColor;
  border-right-color: transparent;
  vertical-align: -0.125em;
`

type Props = {
  color: string
}
export const LoadingSpinner: React.FC<Props> = (props) => (
  <Spinner role="status" style={{ color: props.color ?? '#FFF' }} />
)
